import gql from "graphql-tag";
export const AVAILABLE_SERVICES_SEARCH_QUERY = gql`
  query availableServices(
    $destinationId: ID!
    $agentId: ID!
    $department: String
    $startDate: DateTimeType
    $endDate: DateTimeType
    $serviceType: GtServiceType
    $adults: String
    $children: String
    $infants: String
    $supplierName: String
    $yearShift: Int
    $first: Int
  ) {
    availableServices(
      searchParams: {
        destinationId: $destinationId
        agentId: $agentId
        department: $department
        startDate: $startDate
        endDate: $endDate
        serviceType: $serviceType
        adults: $adults
        children: $children
        infants: $infants
        yearShift: $yearShift
      }
      filter: { supplierNameContains: $supplierName }
      first: $first
    ) {
      edges {
        node {
          id
          serviceName
          serviceId
          supplierName
          supplierId
          priceFrom
          priceFromCurrencyCode
          rateTypeCode
          headOfficeName
          supplier {
            id
            code
            boardBasis
            imageURL
            description
            defaultRateTypeCode
            currencyCode
            extrasChildPrice
            services(filter: { not_in_use_eq: false }) {
              edges {
                node {
                  id
                  name
                  stdOccupancy
                  typeName
                }
              }
            }
          }
          service {
            stdOccupancy
            code
            imageURL
            description
            typeName
          }
          prices {
            id
            date
            currency
            ratePlan
            rateCode
            rateTypeName
            adultPrice
            childPrice
            infantPrice
            itemPrice
            isClosed
            isOnRequest
            remaining
          }
        }
      }
    }
  }
`;
export const SUPPLIERS_QUERY = gql`
  query adhocSuppliersList(
    $destinationId: ID
    $serviceType: GtServiceType
    $first: Int
    $supplierName: String
  ) {
    adhocSuppliersList: suppliers(
      first: $first
      filter: {
        destinationId: $destinationId
        service_type: $serviceType
        name_contains: $supplierName
        not_in_use_eq: false
      }
      orderBy: { fieldName: "name", direction: ASC }
    ) {
      edges {
        node {
          id
          name
          code
          boardBasis
          defaultRateTypeCode
          currencyCode
          currencyExchangeRate
          description
          imageURL
          extrasChildPrice
          headOfficeName
          services(filter: { not_in_use_eq: false }) {
            edges {
              node {
                id
                name
                stdOccupancy
                maxOccupancy
              }
            }
          }
        }
      }
    }
  }
`;
export const SERVICE_TYPES_QUERY = gql`
  query serviceTypes($supplierType: GtServiceType!) {
    serviceTypes(supplierType: $supplierType) {
      edges {
        node {
          id
          name
          minOccupancy
          maxOccupancy
          stdOccupancy
          hidden
          notInUse
        }
      }
    }
  }
`;
export const CREATE_ADHOC_SERVICE = gql`
  mutation createAdhocService($serviceInput: ServiceInput!, $supplierId: ID!) {
    createService(supplierId: $supplierId, serviceInput: $serviceInput) {
      id
      name
      minOccupancy
      maxOccupancy
      stdOccupancy
    }
  }
`;
export const UPDATE_ADHOC_SERVICE = gql`
  mutation createAdhocService($serviceInput: ServiceInput!, $serviceId: ID!) {
    updateService(id: $serviceId, serviceInput: $serviceInput) {
      id
      name
    }
  }
`;
export const CREATE_ADHOC_SUPPLIER = gql`
  mutation createAdhocSupplier($supplierInput: SupplierInput!) {
    createSupplier(supplierInput: $supplierInput) {
      id
      name
      description
      imageURL
      defaultRateTypeCode
      currencyCode
      currencyExchangeRate
      extrasChildPrice
      boardBasis
      services {
        edges {
          node {
            id
            name
          }
        }
      }
      __typename
    }
  }
`;
export const GT_CONTENT_HUB_SUPPLIERS = gql`
  query externalSupplier($filter: SupplierFilterInput) {
    externalSuppliers: suppliers(filter: $filter) {
      name
      locationName
      imageURL
      description
      phoneNumber
      source {
        id
        name
        provider
      }
    }
  }
`;
export const GT_CONTENT_HUB_SUPPLIER_DETAILS = gql`
  query externalSupplierDetails($id: ID!, $provider: Provider!) {
    externalSupplierDetails: supplierDetails(id: $id, provider: $provider) {
      name
      locationName
      description
      imageURL
      phoneNumber
      address
      contents {
        name
        description
        imageURL
      }
      source {
        id
        name
        provider
      }
    }
  }
`;
export const SERVICE_NOTES = gql`
  query serviceNotes($filter: ServiceNoteFilterType) {
    serviceNotes(filter: $filter) {
      edges {
        node {
          id
          description
        }
      }
    }
  }
`;
export const SERVICE_INFO = gql`
  query serviceInfo($id: ID!) {
    serviceInfo: service(id: $id) {
      id
      extrasChildPrice
      hiddenByType
      skipAgentCommission
      pickupPoint
      dropoffPoint
      pickupTime
      dropoffTime
      noReport
      linkedServices {
        edges {
          node {
            id
            name
          }
        }
      }
    }
  }
`;
export const AVAILABLE_SUPPLIERS_QUERY = gql`
  query availableSuppliers(
    $search: AvailableServicesSearchInput!
    $first: Int
    $filter: AvailableServiceFilterType
    $after: String
    $includeUnpriced: Boolean
    $skipDetails: Boolean
    $page: Int!
    $pageSize: Int!
    $orderBy: SortOrderType
  ) {
    availableServicesBySupplier(
      first: $first
      after: $after
      searchParams: $search
      filter: $filter
      includeUnpriced: $includeUnpriced
      skipDetails: $skipDetails
      page: $page
      pageSize: $pageSize
      orderBy: $orderBy
    ) {
      totalCount
      pageInfo {
        hasNextPage
        endCursor
      }
      edges {
        node {
          id
          supplierId
          supplierName
          headOfficeName
          supplierCode
          boardBasis
          priceFrom
          priceFromCurrencyCode
          imageURL
          description
          serviceType
          currencyCode
          defaultRateTypeCode
          extrasChildPrice
          availableServices {
            id
            serviceName
            serviceId
            supplierName
            supplierId
            priceFrom
            priceFromCurrencyCode
            rateTypeCode
            service {
              stdOccupancy
              code
              imageURL
              description
            }
            prices {
              id
              date
              currency
              ratePlan
              rateCode
              rateTypeName
              adultPrice
              childPrice
              infantPrice
              itemPrice
              isClosed
              isOnRequest
              remaining
            }
          }
        }
      }
    }
  }
`;

//11058 - markup table lookup for custom priced adhoc items
export const SERVICE_MARKUP_QUERY = gql`
  query serviceMarkup(
    $serviceId: ID!
    $date: DateTimeType!
    $agentId: ID
    $department: String
    $itineraryCreationDate: DateTimeType
  ) {
    serviceMarkup(
      serviceId: $serviceId
      date: $date
      agentId: $agentId
      department: $department
      itineraryCreationDate: $itineraryCreationDate
    )
  }
`;



// WEBPACK FOOTER //
// ./src/components/gt/itineraries/builder/tools/adhoc-item-gql.js